module.exports = __webpack_public_path__ + "static/img/pls.ff9ce16e.png";